import { useRuntimeConfig } from '@xing-com/crate-xinglet/internal';

export const useVisitorId = (): string => {
  const { visitorId = 'FALLBACK' } = useRuntimeConfig();
  return visitorId;
};
